/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppMessageStatusSchema = z.enum(['pending', 'sent', 'delivered', 'read', 'failed'])

export type WhatsAppMessageStatusSchema = z.infer<typeof whatsAppMessageStatusSchema>
